import { useEffect, useMemo, useState } from "react";
import { Button, Snackbar, Slide, Paper } from "@mui/material";
import InstallDesktopOutlinedIcon from "@mui/icons-material/InstallDesktopOutlined";
import { usePwaInstall } from "@/usePwaInstall";

export default function ServiceWorkerWrapper() {
  const { isInstallable, promptInstall, isIOS, isStandalone } = usePwaInstall();
  const [showIOS, setShowIOS] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isStandalone) {
      setShowIOS(false);
      return;
    }
    if (isIOS) {
      const t = window.setTimeout(() => setShowIOS(true), 600);
      return () => window.clearTimeout(t);
    }
    setShowIOS(false);
  }, [isIOS, isStandalone]);

  useEffect(() => {
    if (isInstallable) setDismissed(false);
  }, [isInstallable]);

  const showInstallButton = useMemo(
    () => isInstallable && !isStandalone && !dismissed,
    [dismissed, isInstallable, isStandalone],
  );

  if (isStandalone) return null;

  return (
    <>
      {showInstallButton && (
        <Paper
          elevation={6}
          sx={{
            position: "fixed",
            right: 16,
            bottom: 16,
            p: 1.5,
            display: "flex",
            gap: 1,
            alignItems: "center",
            zIndex: (t) => t.zIndex.snackbar + 1,
          }}
        >
          <Button
            variant="contained"
            startIcon={<InstallDesktopOutlinedIcon />}
            onClick={async () => {
              const result = await promptInstall();
              if (result?.outcome !== "accepted") setDismissed(true);
            }}
          >
            Install app
          </Button>
          <Button variant="text" onClick={() => setDismissed(true)}>
            Not now
          </Button>
        </Paper>
      )}

      <Snackbar
        open={showIOS && !showInstallButton}
        onClose={() => setShowIOS(false)}
        message="On iPhone/iPad: Share → Add to Home Screen to install"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        TransitionComponent={(props) => <Slide {...props} direction="up" />}
      />
    </>
  );
}
